import { render, staticRenderFns } from "./DialogArteDivulgacao.vue?vue&type=template&id=283c877d&lang=pug"
import script from "./DialogArteDivulgacao.vue?vue&type=script&lang=js"
export * from "./DialogArteDivulgacao.vue?vue&type=script&lang=js"
import style0 from "./DialogArteDivulgacao.vue?vue&type=style&index=0&id=283c877d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports